'use client';
import { SessionProvider } from 'next-auth/react';
import { NEXT_PUBLIC_DISABLE_AUTH } from '@/shared/envs';
import { useEffect } from 'react';
import etaLoader from '@/sharedTypes/EtaLoader';

const tokenRefreshSeconds = 50;

export function Providers({ children }: { children: React.ReactNode }) {
  // Always render SessionProvider to allow optional sign-in even when auth is disabled
  // The difference is that when auth is disabled, authentication is not required
  if (NEXT_PUBLIC_DISABLE_AUTH) {
    console.log('Authentication disabled by default - SessionProvider available for optional sign-in');
  }
  
  useEffect(() => {
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('startingUp', 1);
    }
  }, []);

  return (
    <SessionProvider refetchInterval={tokenRefreshSeconds} refetchOnWindowFocus>
      {children}
    </SessionProvider>
  );
}
